import axios from 'CanExConfig/axios'

const endpoint = '/api/candidate/static/countries'

export const getStaticCountries = async () => {
  const response = await axios(endpoint, {
    method: 'GET',
  })

  return response.data
}
